const P = process.env.PUBLIC_URL || "";

export const ASSETS = {
  lunaIdle: `${P}/mascot/luna_idle.png`,
  lunaCelebrate: `${P}/mascot/luna_celebrate.png`,
  petEgg: `${P}/mascot/pet_egg.png`,
  petFox: `${P}/mascot/pet_fox.png`,
  worldBg: "https://static.prod-images.emergentagent.com/jobs/d27d676b-11ca-4f8d-82c4-f021a7f14ca0/images/9517b2d6fb92ec7606586365ff2827cb7f8fac1011543fd4f6048bd1773b24ed.png",
};

// Custom-designed pet artwork (consistent across all platforms).
export const PET_IMAGES = {
  fox: `${P}/mascot/pet_fox.png`,
  cat: `${P}/mascot/pets/cat.png?v=2`,
  dog: `${P}/mascot/pets/dog.png?v=2`,
  panda: `${P}/mascot/pets/panda.png?v=2`,
  penguin: `${P}/mascot/pets/penguin.png?v=2`,
  dragon: `${P}/mascot/pets/dragon.png?v=2`,
  unicorn: `${P}/mascot/pets/unicorn.png?v=2`,
  rabbit: `${P}/mascot/pets/rabbit.png?v=2`,
  lion: `${P}/mascot/pets/lion.png?v=2`,
  frog: `${P}/mascot/pets/frog.png?v=2`,
  owl: `${P}/mascot/pets/owl.png?v=2`,
  monkey: `${P}/mascot/pets/monkey.png?v=2`,
};

// Custom-designed accessory artwork, keyed by the stored id (emoji) for compatibility.
export const ACC_IMAGES = {
  "🎩": `${P}/mascot/acc/tophat.png?v=2`,
  "🧢": `${P}/mascot/acc/cap.png?v=2`,
  "👑": `${P}/mascot/acc/crown.png?v=2`,
  "👓": `${P}/mascot/acc/glasses.png?v=2`,
  "🎀": `${P}/mascot/acc/bow.png?v=2`,
  "🕶️": `${P}/mascot/acc/sunglasses.png?v=2`,
  "🎓": `${P}/mascot/acc/grad.png?v=2`,
  "🧣": `${P}/mascot/acc/scarf.png?v=2`,
  "⭐": `${P}/mascot/acc/star.png?v=2`,
  "🌸": `${P}/mascot/acc/flower.png?v=2`,
};
